import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="container-x pb-14 md:pb-20">
      <div className="relative overflow-hidden rounded-lg">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20elegant%20backstage%20corridor%20with%20warm%20amber%20wall%20lamps%20and%20deep%20crimson%20tones%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20editorial%20photography%20high%20detail&width=1600&height=700&seq=gua-cta-01&orientation=landscape"
            alt="后台走廊暖光氛围图，象征线索投递与事件追踪"
            title="独家吃瓜 线索投递"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/45"></div>
        </div>

        <div className="relative z-10 flex flex-col gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12 md:py-16">
          <div className="max-w-xl">
            <p className="text-xs font-medium tracking-[0.2em] text-accent-300">TIP LINE / 线索投递</p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              你看到的那条线，也许正是缺的那一块
            </h2>
            <p className="mt-4 text-sm leading-7 text-background-200">
              如果你手里有可公开查证的链接、公告截图或时间点，欢迎投递。我们不会采用无法核实的私下说法，但会把它列为后续核对的方向。
            </p>
          </div>
          <div className="flex shrink-0 flex-col gap-3 sm:flex-row md:flex-col">
            <Link
              to="/about#contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line"></i>
              投递线索
            </Link>
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-book-2-line"></i>
              先逛逛档案
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}